import { faHome } from '@fortawesome/pro-regular-svg-icons'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'

import { FC } from 'react'
import { Link } from 'react-router-dom'

import { DropdownMenuItem } from 'components/DropdownMenu'
import { useTranslation } from 'services/i18n'
import { getUrlWithAppSource } from 'utils/getUrlWithAppSource'

export const GoToPlatform: FC = () => {
  const { t } = useTranslation('translation', {
    keyPrefix: 'user_menu',
  })

  return (
    <Link
      to={getUrlWithAppSource({
        sourceType: 'kaila_user_menu',
        url: window.origin,
      })}
    >
      <DropdownMenuItem className="h-10">
        <FontAwesomeIcon icon={faHome} className="mr-2 w-4" />
        <span>{t('go_to_platform')}</span>
      </DropdownMenuItem>
    </Link>
  )
}
